import styled from "@emotion/styled";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { API } from "../../API";
import AsyncImage from "./AsyncImage";

interface Props {
  url: string;
  getSignedPhotoUrl: API["getSignedPhotoUrl"];
  className?: string;
  onClick?: (url: string) => void;
}

const SignedS3Photo = (props: Props) => {
  const signed = useQuery({
    queryKey: [props.url],
    queryFn: () => props.getSignedPhotoUrl(props.url),
    enabled: props.url.startsWith("s3://"),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });

  const url = /^(blob|capacitor):/.test(props.url) ? props.url : signed.data?.url;

  if (url === undefined) {
    return <></>;
  }

  const handleClick = () => {
    if (props.onClick !== undefined) {
      props.onClick(url);
    }
  };

  return (
    <SignedS3Photo.Root className={props.className} onClick={handleClick}>
      <AsyncImage src={url} />
    </SignedS3Photo.Root>
  );
};

SignedS3Photo.Root = styled.div`
  display: flex;

  .AsyncImage {
    background-size: cover;
    width: 100%;
    height: 100%;
  }
`;

export default SignedS3Photo;
